<template>
    <div>
        <header class="header" :class="{ 'header--dropdown-open': dropdownActive !== null }" id="site-header">
            <div class="header__inner">
                <div class="header__mobile-toggle" @click="toggleMobileMenu">
                    <i :class="{
                        'icon-menu': !showMobileMenu,
                        'icon-close': showMobileMenu
                    }"></i>
                </div>
                <div class="header__logo-wrapper">
                    <a class="header__logo" title="Home Page" :href="homePageUrl"></a>
                </div>
                <nav class="header__nav header__nav--primary">
                    <NavigationItem 
                        @click="toggleDropdown(item)" 
                        v-for="item in primaryNavigation" 
                        :key="item.key"
                        :item="item" 
                        :dropdown-active="dropdownActive"
                    />
                </nav>
                <nav class="header__nav header__nav--secondary">
                    <NavigationItem 
                        @click="toggleDropdown(item)" 
                        v-for="item in secondaryNavigation" 
                        :key="item.key" 
                        :item="item"        
                        :dropdown-active="dropdownActive" 
                    />
                    <div class="header__nav-search" :class="{
                        'header__nav-search--active': dropdownActive !== null && dropdownActive.key === 'Search'
                    }" @click="toggleDropdown({key: 'Search'})">
                        <span>
                            <i class="icon-search"></i>
                        </span>
                    </div>
                </nav>
            </div>
            <Transition>
                <div class="header__nav-dropdown" v-show="dropdownActive !== null" style="display: none;">
                    <template v-for="(item, index) in navigationItems" :key="index">
                        <div class="header__nav-dropdown-inner" v-if="dropdownActive !== null && dropdownActive.key === item.key">
                            <div class="header__nav-dropdown-intro">
                                <div class="header__nav-dropdown-intro-text">{{item.introText}}</div>
                                <div class="header__nav-dropdown-intro-actions">
                                    <a 
                                        class="header__nav-dropdown-primary-action"
                                        v-if="item.introPrimaryAction"
                                        :href="item.introPrimaryAction.Url" 
                                    ><span>{{ item.introPrimaryAction.Name}}</span></a>
                                    <a 
                                        class="header__nav-dropdown-secondary-action"
                                        v-if="item.introSecondaryAction"
                                        :href="item.introSecondaryAction.Url" 
                                    >{{ item.introSecondaryAction.Name}}</a>
                                </div>
                            </div>
                            <div class="header__nav-dropdown-component">
                                <Transition>
                                    <Professionals v-if="item.dropdownComponent === 'Professionals'" />
                                </Transition>
                                <Transition>
                                    <Locations v-if="item.dropdownComponent === 'Locations'" />
                                </Transition>
                                <Transition>
                                    <Services v-if="item.dropdownComponent === 'Services'" />
                                </Transition>
                                <Transition>
                                    <News v-if="item.dropdownComponent === 'News'" />
                                </Transition>
                                <Transition>
                                    <Insights v-if="item.dropdownComponent === 'Insights'" />
                                </Transition>
                                <Transition>
                                    <About v-if="item.dropdownComponent === 'About'" />
                                </Transition>
                            </div>
                        </div>
                    </template>
                    <div class="header__nav-dropdown-inner" v-if="dropdownActive !== null && dropdownActive.key === 'Search'">
                        <div class="header__nav-dropdown-component">
                            <SearchDropdown :frequent-searches="frequentlySearchedTerms"/>
                        </div>
                    </div>
                </div>
            </Transition>
        </header>
        <Transition>
        <div class="overlay-backdrop" @click="dropdownActive = null" v-if="dropdownActive !== null"></div>
        </Transition>
    </div>
</template>

<script>
import NavigationItem from './NavigationItem';
import SearchDropdown from './SearchDropdown';
import Professionals from './Professionals';
import Locations from './Locations';
import Services from './Services';
import News from './News';
import Insights from './Insights';
import About from './About';

export default {
    props: ["homePageUrl", "activeNavItem", "frequentlySearchedTerms", "navigationItems"],
    components: {
        NavigationItem,
        SearchDropdown,
        Professionals,
        Locations,
        Services,
        News,
        Insights,
        About
    },
    data() {
        return {
            dropdownActive: null,
            showMobileMenu: false,
        }
    },
    computed: {
        primaryNavigation: function () {
            return this.navigationItems.filter((item) => {
                return item.type === 'primary';
            });
        },
        secondaryNavigation: function () {
            return this.navigationItems.filter((item) => {
                return item.type === 'secondary';
            });
        }
    },  
    mounted() { 
      
    },
    watch: {
        dropdownActive: function () {
            if (this.dropdownActive !== null) {
                document.querySelector('body').classList.add("overlay-active");
            } else {
                document.querySelector('body').classList.remove("overlay-active");
            }
        }
    },
    methods: {
        toggleDropdown: function (dropdown) {
            if (dropdown.dropdownComponent === "") {
                return
            }
            if (this.dropdownActive !== null && dropdown.key === this.dropdownActive.key) {
                this.dropdownActive = null;
                return
            }
            this.dropdownActive = dropdown;
        },
        toggleMobileMenu: function () {
            this.showMobileMenu = !this.showMobileMenu;
        }
    }
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 200ms ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>

